import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_7 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_8 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_9 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_12 = { class: "dropdown" }
const _hoisted_13 = { class: "dropdown-menu" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_AddModalCategProduit = _resolveComponent("AddModalCategProduit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "d-sm-flex align-items-center" }, [
          _createElementVNode("a", {
            class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
            href: "#",
            "data-bs-toggle": "modal",
            "data-bs-target": "#AddModalCategProduit"
          }, [
            _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }),
            _createTextVNode(" Ajouter une catégorie de produit ")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", {
            class: "search-box position-relative me-15",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "mot",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
              onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
              class: "form-control shadow-none text-black rounded-0 border-0",
              placeholder: "Rechercher une catégorie de produit"
            }, null, 544), [
              [_vModelText, _ctx.searchTerm]
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("button", {
              type: "submit",
              class: "bg-transparent text-primary transition p-0 border-0"
            }, [
              _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
            ], -1))
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Code "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Nom "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Description "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Niveau de risque "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                }, " Actions")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categProduits, (categProduit, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_7, _toDisplayString(categProduit.code), 1),
                  _createElementVNode("td", _hoisted_8, _toDisplayString(categProduit.name), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(categProduit.description), 1),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(categProduit.risk_level), 1),
                  _createElementVNode("td", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _cache[7] || (_cache[7] = _createElementVNode("span", {
                        class: "badge text-white bg-primary fs-15 dropdown-toggle",
                        "data-bs-toggle": "dropdown",
                        "aria-expanded": "false"
                      }, [
                        _createTextVNode(" Actions "),
                        _createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
                      ], -1)),
                      _createElementVNode("ul", _hoisted_13, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#AddModalCategProduit",
                            onClick: ($event: any) => (_ctx.moddifier(categProduit))
                          }, [...(_cache[5] || (_cache[5] = [
                            _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                            _createTextVNode(" Modifier ", -1)
                          ]))], 8, _hoisted_14)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);",
                            onClick: ($event: any) => (_ctx.suppression(categProduit.id, _ctx.categProduits, 'categProduit', 'categProduit'))
                          }, [...(_cache[6] || (_cache[6] = [
                            _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                            _createTextVNode(" Supprimer ", -1)
                          ]))], 8, _hoisted_15)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createVNode(_component_AddModalCategProduit, {
      item: _ctx.selectedItem,
      onClose: _ctx.recharger
    }, null, 8, ["item", "onClose"])
  ], 64))
}